export const createStripeOptions = () => {
    return {
        style: {
            base: {
                color: '#464041',
                letterSpacing: '0.025em',
                fontFamily: 'Londrina Solid',
                fontWeight: 300,
                fontSize: '18px',
                '::placeholder': {
                    color: '#DDD',
                },
            },
            invalid: {

            },
        },
    };
};


// WEBPACK FOOTER //
// ./src/containers/BookingFlow/stripeOptions.js